import Cookies from 'js-cookie'

const TokenKey = 'token'

export const getToken = () => Cookies.get(TokenKey)

export const setToken = (token) => Cookies.set(TokenKey, token)

export const removeToken = () => Cookies.remove(TokenKey)

export const setSession = (key,val) => localStorage.setItem(key, JSON.stringify(val))

export const getSession = (key) => {
    const val = localStorage.getItem(key)
    try {
        return JSON.parse(val)
    } catch (e) {
        // 兼容历史脏数据（如旧版把 undefined 存成字符串 "undefined"），解析失败一律返回 null
        return null
    }
}

export const sessionClearAll = () => {
    localStorage.clear()
}
